import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"

import "./TopNavigation.vue?vue&type=style&index=0&id=5ae398bb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae398bb"]])

export default __exports__